import { useAuth } from "../context/auth";

export default function useUserId() {
    return useAuth()?.user?.user_id ?? null;
}
